var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNextDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "468C6673-2484-4289-AA93-5E17ADBE3D52") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Car-insurance---12---Filters",
    transform: "translate(-850.000000, -1463.000000)",
    fill: "#202020",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-20",
    transform: "translate(65.000000, 250.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(502.000000, 1210.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M295,3 C291.817366,3 288.765187,4.26427668 286.514775,6.51477489 C284.264277,8.76510168 283,11.8174513 283,15 C283,18.1825487 284.264277,21.2348126 286.514775,23.4852251 C288.765102,25.7357233 291.817451,27 295,27 C297.106328,27 299.175713,26.4455182 300.999957,25.3923543 C302.824201,24.339019 304.338933,22.824287 305.392354,20.9999571 C306.445518,19.175713 307,17.1063278 307,15 C307,11.8173656 305.735723,8.76518739 303.485225,6.51477489 C301.234898,4.26427668 298.182549,3 295,3 Z M298.069621,15.2399126 L292.407804,20.8991579 C292.344856,20.9637774 292.25814,21.0002743 292.167905,20.9999423 C292.077669,20.999103 291.991454,20.9629426 291.927838,20.8991579 C291.796087,20.7662331 291.796087,20.5519489 291.927838,20.4192041 L297.349228,14.9999571 L291.929981,9.58071014 C291.79823,9.44795251 291.79823,9.23366833 291.929981,9.10075642 C291.993263,9.03630403 292.079645,8.99997429 292.170047,8.99997429 C292.260282,8.99997429 292.346832,9.03630231 292.409947,9.10075642 L298.071764,14.7600017 C298.202846,14.893595 298.201843,15.1078792 298.06942,15.2401269 L298.069621,15.2399126 Z",
    id: "Shape-Copy-2"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextDark);
export default __webpack_public_path__ + "static/media/next-dark.db6b0c54c2e2d65042844100c9f946d6.svg";
export { ForwardRef as ReactComponent };